export default "__VITE_ASSET__DYJDqi9g__"